import * as React from 'react';

import ProfileCard from 'components/cards/profile-card/ProfileCard';
import StatusLabel from 'components/status-label/StatusLabel';

import ProfileGenderAdditional from '../../components/profile-gender-additional/ProfileGenderAdditional';
import ProfileEthnicity from '../../components/profile-ethnicity/ProfileEthnicity';

import { __t, applyTranslations } from 'utils/language';

import './profile-self-identity.scss';

applyTranslations(require('locales/common/collabary-common.i18n.json'));
applyTranslations(require('./profile-self-identity.i18n.json'));

import type { InfluencerProfileForm } from 'types';

interface Props {
  profile: InfluencerProfileForm,
  hideNew: boolean,
  onChange: (profile: Partial<InfluencerProfileForm>) => void
}

const COMMON_MSG_KEY = 'collabary_common';
const MSG_KEY = 'profile_self_identity';

const ProfileSelfIdentity: React.FC<Props> = ({
  profile,
  hideNew,
  onChange
}) => (
  <div
    id="profile-self-identity"
    className="profile-self-identity"
  >
    <div className="profile-self-identity__title">
      <div className="profile-self-identity__title-text">
        {__t(`${MSG_KEY}.title`)}
      </div>
      {
        !hideNew && (
          <div className="profile-self-identity__title-marker">
            <StatusLabel
              label={(__t(`${COMMON_MSG_KEY}.basics.new`) || '').toUpperCase()}
              layout="marker"
            />
          </div>
        )
      }
    </div>
    <div className="profile-self-identity__description">
      {__t(`${MSG_KEY}.description`)}
    </div>
    <ProfileCard
      classNameContents="profile-self-identity__contents"
    >
      <ProfileGenderAdditional
        profile={profile}
        onChange={onChange}
      />
      <ProfileEthnicity
        profile={profile}
        onChange={onChange}
      />
    </ProfileCard>
  </div>
);

export default ProfileSelfIdentity;
